import { DateTrustCode } from 'entities-next/common'
import { FundingRound } from 'entities-next/fundingRounds'
import { EMPTY_FORM_VALUE } from 'utils-next/forms'
import * as Yup from 'yup'

export type FundingRoundFormData = Omit<FundingRound, 'roundSize' | 'targetMoney' | 'valuationPreMoney'> & {
  roundSize: string
  targetMoney: string
  valuationPreMoney: string
}

export function getFundingRoundValidation() {
  return Yup.object().shape({
    roundSize: Yup.number(),
    targetMoney: Yup.number(),
    valuationPreMoney: Yup.number(),
  })
}

export function parseFundingRoundToFormData({
  roundType,
  announcedOn,
  roundSize,
  targetMoney,
  valuationPreMoney,
  ...otherData
}: FundingRound): FundingRoundFormData {
  return {
    roundType: roundType || EMPTY_FORM_VALUE,
    announcedOn: announcedOn || EMPTY_FORM_VALUE,
    roundSize: roundSize ? String(roundSize) : EMPTY_FORM_VALUE,
    targetMoney: targetMoney ? String(targetMoney) : EMPTY_FORM_VALUE,
    valuationPreMoney: valuationPreMoney ? String(valuationPreMoney) : EMPTY_FORM_VALUE,
    ...otherData,
  }
}

export function parseFormFundingRound({
  announcedOn,
  roundSize,
  targetMoney,
  valuationPreMoney,
  ...fundingRoundData
}: FundingRoundFormData): FundingRound {
  return {
    ...fundingRoundData,
    roundSize: roundSize ? Number(roundSize) : undefined,
    targetMoney: targetMoney ? Number(targetMoney) : undefined,
    targetMoneyCurrency: targetMoney ? 'USD' : undefined,
    valuationPreMoney: valuationPreMoney ? Number(valuationPreMoney) : undefined,
    valuationPreMoneyCurrency: valuationPreMoney ? 'USD' : undefined,
    announcedOn: announcedOn || undefined,
    announcedOnTrustCode: announcedOn ? DateTrustCode.yearDayMonth : DateTrustCode.null,
  }
}
